<template>
	<div class="page">
		<header>
			<h1>
				Architecture
				<br />de maison
			</h1>
		</header>
		<article>
			<div class="gauche">
				<h2>Simple</h2>
				<div
					:class="architecture == 'Simple' ? 'selected option' : 'option'"
					id="architecture_simple"
					@click="handleArchitecture('architecture_simple', 'Simple')"
				>
					<img v-if="terrain == 'Plat'" src="../assets/02-simpleplat.png" />
					<img v-else src="../assets/02-simplepente.png" />
					<div class="exemple" id="exemples_simples" @click="openGalerieSimple()">
						<img src="../assets/eye.png" />Exemples de constructions simples
					</div>
				</div>
			</div>
			<div class="droite">
				<ul id="images" style="display: none">
					<li>
						<img src="../assets/logo-a4.png" alt="Picture 1" />
					</li>
				</ul>
				<h2>Complexe</h2>
				<div
					:class="architecture == 'Complexe' ? 'selected option' : 'option'"
					id="architecture_complexe"
					@click="handleArchitecture('architecture_complexe', 'Complexe')"
				>
					<img v-if="terrain == 'Plat'" src="../assets/02-complexeplat.png" />
					<img v-else src="../assets/02-complexepente.png" />
					<div class="exemple" id="exemples_complexes" @click="openGalerieComplexe()">
						<img src="../assets/eye.png" />Exemples de constructions complexes
					</div>
				</div>
			</div>
		</article>
		<footer>
			<router-link to="/terrain" class="button back">
				<i class="fa fa-angle-left"></i>
			</router-link>
			<router-link v-if="ready || architecture.length > 1" to="/surface" class="button medium">
				Surface habitable
				<i class="fa fa-angle-right"></i>
			</router-link>
		</footer>
		<div id="galerie-simple">
			<div class="close" @click="closeGalerie()">
				<i class="fal fa-times-circle"></i>
			</div>
			<slider animation="fade">
				<slider-item v-for="(item, index) in imagesSimple" :key="index">
					<img :src="item.image" />
				</slider-item>
			</slider>
		</div>
		<div id="galerie-complexe">
			<div class="close" @click="closeGalerie()">
				<i class="fal fa-times-circle"></i>
			</div>
			<slider animation="fade">
				<slider-item v-for="(item, index) in imagesComplexe" :key="index">
					<img :src="item.image" />
				</slider-item>
			</slider>
		</div>
	</div>
</template>
<script>
	export default {
		name: "Architecture",
		components: {},
		data() {
			return {
				ready: false,
				imagesSimple: [],
				imagesComplexe: []
			};
		},
		computed: {
			terrain() {
				return this.$store.state.terrain;
			},
			architecture() {
				return this.$store.state.architecture;
			}
		},
		methods: {
			openGalerieComplexe(e) {
				var galerie = document.getElementById("galerie-complexe");
				galerie.classList.add("active");
				this.$store.commit("setTimer", 60);
			},
			openGalerieSimple(e) {
				var galerie = document.getElementById("galerie-simple");
				galerie.classList.add("active");
				this.$store.commit("setTimer", 60);
			},
			closeGalerie() {
				var galerie = document.getElementById("galerie-complexe");
				var galerie2 = document.getElementById("galerie-simple");
				galerie.classList.remove("active");
				galerie2.classList.remove("active");
				this.$store.commit("setTimer", 60);
			},
			handleArchitecture(e, a) {
				this.ready = true;
				var options = document.querySelectorAll(".option");
				var element = document.getElementById(e);
				options.forEach(el => {
					el.classList.remove("selected");
				});
				element.classList.add("selected");
				this.$store.commit("setArchitecture", a);
			}
		},
		mounted() {
			this.$store.commit("setTimer", 60);
			if (this.$store.state.terrain == "Plat") {
				this.imagesSimple = [
					{
						image:
							"http://passivhome-construction.com/wp-content/uploads/2019/09/Passiv01.jpg039Home-plat-simple-201909-01.jpg"
					}
				];
				this.imagesComplexe = [
					{
						image:
							"http://passivhome-construction.com/wp-content/uploads/2019/09/Passiv01.jpg039Home-plat-complexe-201909-01.jpg"
					},
					{
						image:
							"http://passivhome-construction.com/wp-content/uploads/2019/09/Passiv02.jpg039Home-plat-complexe-201909-02.jpg"
					},
					{
						image:
							"http://passivhome-construction.com/wp-content/uploads/2019/09/Passiv03.jpg039Home-plat-complexe-201909-03.jpg"
					},
					{
						image:
							"http://passivhome-construction.com/wp-content/uploads/2019/09/Passiv04.jpg039Home-plat-complexe-201909-04.jpg"
					}
				];
			} else {
				this.imagesSimple = [
					{
						image:
							"http://passivhome-construction.com/wp-content/uploads/2019/09/Passiv03.jpg039Home-pente-simple-201909-03.jpg"
					},
					{
						image:
							"http://passivhome-construction.com/wp-content/uploads/2019/09/Passiv02.jpg039Home-pente-simple-201909-02.jpg"
					},
					{
						image:
							"http://passivhome-construction.com/wp-content/uploads/2019/09/Passiv01.jpg039Home-pente-simple-201909-01.jpg"
					}
				];
				this.imagesComplexe = [
					{
						image:
							"http://passivhome-construction.com/wp-content/uploads/2019/09/Passiv01.jpg039Home-pente-complexe-201909-01.jpg"
					}
				];
			}
		}
	};
</script>

<style lang="less">
	#galerie-simple,
	#galerie-complexe {
		position: fixed;
		top: 50px;
		left: 50px;
		width: calc(~"100vw - 100px");
		height: calc(~"100vh - 100px");
		z-index: 9999;
		background: white;
		display: none;
		transition: all 0.3s ease;
		transform: translateY(100%);
		.close {
			position: absolute;
			top: 0px;
			right: 0px;
			font-size: 40px;
			z-index: 100;
			transform: translate(40px, -40px);
		}
		.slider {
			width: 100% !important;
			height: 100% !important;
			.slider-btn {
				background: none;
				top: 50px;
				height: calc(~"100% - 100px");
			}
			.slider-item {
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: auto;
					height: auto;
					max-width: 100%;
					max-height: 100%;
				}
			}
		}
		&.active {
			display: block;
			transform: translateY(0px);
		}
	}
</style>